import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

if( $( '.map-section' ).length ) {
  var dir = '/app/themes/villagebrewery/resources/assets/images';
  var beerListSection = document.querySelector( '.beer-list' );
  
  mapboxgl.accessToken = 'pk.eyJ1IjoiZmxpcHBkZXZzIiwiYSI6ImNrc2hxc2x0ZDF3eGQyb29hZDNndWhuZXcifQ.NLQN5AjdofpVMB8SBRgDgA';

  // Create Map
  const map = new mapboxgl.Map( {
    container: 'map', // container ID
    style: 'mapbox://styles/flippdevs/cl2hvdwpr002014l23pwi1yxd', // style URL
    center: [-114.0767529, 51.0413564], // starting position [lng, lat]
    zoom: 14, // starting zoom
  } );

  //Add Map Control Options
  map.addControl(new mapboxgl.FullscreenControl());
  map.addControl(new mapboxgl.GeolocateControl({
    positionOptions: {
        enableHighAccuracy: true
    },
    trackUserLocation: true,
    showUserHeading: true
  }));

  // Create an empty array for beer list
  const beerList = [];

  // Wrap fetch into function
  const fetchData = () => {
    fetch( 'https://village.brewerydw.com/api/beerfinder' )

      .then( ( response ) => {
        // JSON that is returned from the server must be converted to a JS object asynchronously.
        if ( ! response.ok ) {
          throw new Error( 'Not 200 OK' );
        }
        return response.json();
      } )

      .then( ( data ) => {
        var dataLocations = data.locations

        dataLocations.forEach( ( elem ) => {

          // Create a marker for each location
          const el = document.createElement( 'div' );
          el.className = 'marker';
          el.style.width = `28px`;
          el.style.height = `28px`;
          el.style.backgroundSize = '100%';

          elem.products.forEach( ( element ) => {
            el.classList.add( `product-${ element.toLowerCase().replace(/\s/g, '') }` ) // Each marker has a class of products carried
            beerList.push( element ) // Push all products into beerlist array
          } )

          // Depending on what type, marker picture changes
          if( elem.type == 'Liquor Stores' ) {
            el.style.backgroundImage = `url(${ dir }/store.svg)`;
          } else {
            el.style.backgroundImage = `url(${ dir }/restaurant.svg)`;
          }

          // Create Popup for each marker
          const popUp = new mapboxgl.Popup( { offset: 2 } ) // add popups
          .setHTML(
            `
            <div>
              <div class="border-b-[1px] border-solid border-black m-2 py-2">
                <h2 class="text-[18px] font-oswald mb-2">${ elem.name }</h2>
                <a class="hover:text-brand" href="https://maps.google.com/?ll=${ elem.lat },${ elem.long }" target="_blank" rel="noreferrer noopener">${ elem.address }</a>
              </div>
              <div class="m-2">
                <p class="text-[14px] font-oswald">Beers Avaliable Here</p>
                <p>${ elem.products.toString().replace(/,/g, ' | ') }</p>
              </div>
            </div>

            `
          )
          
          // Add marker to map
          new mapboxgl.Marker( el )
            .setLngLat( [elem.long, elem.lat] )
            .setPopup( popUp )
            .addTo( map );
        } )

        // Beerlist Array
        let sortedBeerList = [...new Set(beerList)] // Take beerlist array and delete all duplicates
        sortedBeerList.sort() // Sort the array in alphabetical order

        // New Beerlist Array
        sortedBeerList.forEach( ( beer ) => {
          const beerEl = document.createElement( 'div' )
          beerEl.className = `product-${ beer.toLowerCase().replace(/\s/g, '') }` // Each Product has its own class
          beerEl.classList.add( 'beer-filter','beer-style' ) // Add extra classes for styling and identification

          // Create a P tag to display name of product
          const beerElText = document.createElement( 'p' )
          beerElText.textContent = beer
          beerEl.appendChild( beerElText )

          beerListSection.appendChild( beerEl )
        } )

        // Click events for legend
        var marker = document.querySelectorAll( '.marker' )
        var beerItem = document.querySelectorAll( '.beer-filter' )
        var showAllBeer = document.querySelector( '.show-all' )
        
        // Show all click events
        $( showAllBeer ).on( 'click', () => {
          var $map = $( showAllBeer ).parent().parent().parent().find( '#map' );
          
          $map.find( '.mapboxgl-popup' ).hide() // Each time show all is clicked, if any popups exist, they will be hidden

          // Removing beer-active from all legend items
          beerItem.forEach( () => {
            $( beerItem ).removeClass( 'beer-active' )
          } )

          // All markers are displayed on the map
          marker.forEach( ( mark ) => {
            $( mark ).show()
          } )

          // Add beer-active styling to show-all
          $( showAllBeer ).addClass( 'beer-active' )
        })

        // Product in Legend click events
        beerItem.forEach( ( item ) => {
          var $map = $( item ).parent().parent().parent().find( '#map' );
          var $list = $( item ).parent().find( '.beer-style' )

          $( item ).on( 'click', () => {

            $map.find( '.mapboxgl-popup' ).hide() // Hiding all popups

            // Removing all beer-active styling expect for the one clicked
            if( $( item ).hasClass( 'beer-active' ) ) {
              $( item ).removeClass( 'beer-active' )
            } else {
              $list.removeClass( 'beer-active' )
              $( item ).addClass( 'beer-active' )
            }

            // If a marker has the same class of product clicked, then marker will show, otherwise hide
            marker.forEach( ( mark ) => {
              if( $( mark ).hasClass( `product-${ item.textContent.toLowerCase().replace(/\s/g, '') }` ) ) {
                $( mark ).show()
              } else {
                $( mark ).hide()
              }
            } )
          } )
        } )
      } )

      .catch( ( err ) => {
        // An error or `reject` from any of the above `.then()` blocks will end up here.
        console.log( err );
      } );
  }

  // Legend sidebar events
  var closeSideBar = document.querySelector( '.close-sidebar' )
  var openSideBar = document.querySelector( '.open-sidebar' )
  var legend = document.querySelector( '.map-legend' )

  // Hide Legend
  $( closeSideBar ).on( 'click', () => {
    $( legend ).addClass( 'closed' )
    $( openSideBar ).addClass( 'closed' )
  } )

  // Show Legend
  $( openSideBar ).on( 'click', () => {
    $( legend ).removeClass( 'closed' )
    $( openSideBar ).removeClass( 'closed' )
  })

  fetchData();
}
